<template>
    <div class="bank-details">

        <p class="info">Please provide details of the bank account from/to which your
            deposits/withdrawals will be made in relation to your ZFX Trading Account. </p>

        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="320px" class="demo-ruleForm">

            <div style="width:800px;margin: 0 auto">
                <el-form-item label="Location of the Bank :" prop="bank_type">
                    <el-select v-model="ruleForm.bank_type" placeholder="Please Select">
                        <!-- <el-option  :value="val.name" :label="val.name" v-for="(val,key) in country"></el-option> -->
                        <el-option
                                v-for="(item,index) in fieldOptions.bank_type"
                                :value="Number(index)"
                                :label="item"
                                :key="index"
                        ></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="Bank Account Holder :">
                    {{full_name}}
                </el-form-item>

                <el-form-item label="Bank Name :" prop="bank_name">
                    <el-input v-model="ruleForm.bank_name"></el-input>
                </el-form-item>

                <el-form-item label="Bank Address :" prop="bank_address">
                    <el-input v-model="ruleForm.bank_address"></el-input>
                </el-form-item>

                <el-form-item v-if="Number(ruleForm.bank_type)===1" label="Sort Code :" prop="sort_code">
                    <el-input v-model="ruleForm.sort_code"></el-input>
                </el-form-item>

                <el-form-item label="Account Number :" prop="account_number">
                    <el-input v-model="ruleForm.account_number"></el-input>
                </el-form-item>

                <el-form-item label="BIC / SWIFT :">
                    <el-input v-model="ruleForm.bit_swift"></el-input>
                </el-form-item>

                <el-form-item label="IBAN :" prop="iban">
                    <el-input v-model="ruleForm.iban"></el-input>
                </el-form-item>
            </div>

            <dl class="foot-note">
                <dt>Note:</dt>
                <dd>
                    We do not accept funds transfers made by a third party other than from the Trading Account holder,
                    or funds will be rejected and fees may incur.
                    We cannot send funds to a bank account held by a third party beneficairy other than the Trading
                    Account Holder.
                </dd>
            </dl>

            <el-form-item style="margin-top:50px;">
                <el-button @click="resetForm('ruleForm')" class="box-btn-default" style="width: 211px;">BACK</el-button>
                <el-button type="primary" @click="submitForm('ruleForm')" :loading="btn_loading" class="box-btn"
                           style="width: 221px;">NEXT
                </el-button>
            </el-form-item>

        </el-form>
    </div>
</template>

<script>
import * as server from '../action'

export default {
  name: 'BankDetails',
  data () {
    return {
      fieldOptions: {
        bank_type: []
      },
      full_name: '',
      ruleForm: {
        account_number: 0,
        bank_address: '',
        bank_name: '',
        bank_type: 1,
        bit_swift: '',
        iban: '',
        sort_code: 0
      },
      rules: {
        account_number: [
          { required: true, message: 'Please Enter', trigger: 'blur' }
        ],
        bank_address: [
          { required: true, message: 'Please Enter', trigger: 'blur' }
        ],
        bank_name: [
          { required: true, message: 'Please Enter', trigger: 'blur' }
        ],
        bank_type: [
          { required: true, message: 'Please Select', trigger: 'change' }
        ],
        bit_swift: [
          { required: true, message: 'Please Enter', trigger: 'blur' }
        ],
        sort_code: [
          { required: true, message: 'Please Enter', trigger: 'blur' }
        ]
      },
      btn_loading: false
    }
  },
  created () {
    server.certification_apply_index({ step: 4 }).then(result => {
      this.fieldOptions = result.fieldOptions
      this.ruleForm = result.setting
      this.full_name = result.full_name
    })
  },
  methods: {
    submitForm (formName) {
      /* this.$emit('onStopIndex', 3) */
      this.btn_loading = true
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = {
            ...this.ruleForm,
            step: 4
          }
          server
            .certification_apply_save(params)
            .then(res => {
              this.$emit('onStopIndex', 5)
              this.btn_loading = false
            })
            .catch(err => {
              this.btn_loading = false
            })
        } else {
          this.btn_loading = false
          return false
        }
      })
    },
    resetForm (formName) {
      this.$emit('onStopIndex', 3)
    }
  }
}
</script>

<style scoped lang="scss">
    .bank-details {
        .info {
            margin-bottom: 50px;
        }
        .foot-note {

        }
    }
</style>
